import React from 'react'
import { Footer } from './components/Footer'

const FooterConnect = () => {
  return (
    <Footer />
  )
}

export default FooterConnect